import type { ID } from '@octopus-do/octopus-project-core'
import type { AppState } from '@store/types'

export const selectWorkspaceFolders =
  (workspaceId: ID) => (state: AppState) => {
    const workspace = state.dashboard.find((w) => w.id === workspaceId)
    return workspace?.folders || []
  }
